import React from 'react';
import PropTypes from 'prop-types';
import PageSection from './PageSection';

export const FINGERPRINT_BANNER_IMAGE = '//images.ctfassets.net/gtqjh9j40j4m/7HtMz60uFtWzkOdQufz6sr/df9408cc0404c67803128e251e63d7e6/thumbprint.jpg';

const FingerprintBannerPageSection = ({ children }) => (
  <PageSection banner center borderB backgroundImage={{ url: FINGERPRINT_BANNER_IMAGE, position: 'center' }}>
    {children}
  </PageSection>
);

FingerprintBannerPageSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FingerprintBannerPageSection;
